import gql from "graphql-tag";

// Query to get all affiliates
export const ALL_AFFILIATES_QUERY = gql`
  query AllAffiliates($status: String, $limit: Int, $offset: Int) {
    allAffiliates(status: $status, limit: $limit, offset: $offset) {
      id
      userId
      referralCode
      status
      commissionAmount
      totalEarnings
      totalConversions
      pendingPayout
      paidOut
      name
      email
      phoneNumber
      company
      createdAt
      updatedAt
    }
  }
`;

export const ALL_AFFILIATES = ALL_AFFILIATES_QUERY;

export interface AllAffiliatesQueryVariables {
  status?: string;
  limit?: number;
  offset?: number;
}

export interface AllAffiliatesQueryResponse {
  allAffiliates: Array<{
    id: string;
    userId: string;
    referralCode: string;
    status: string;
    commissionAmount: number;
    totalEarnings: number;
    totalConversions: number;
    pendingPayout: number;
    paidOut: number;
    name: string;
    email: string;
    phoneNumber: string;
    company: string;
    createdAt: string;
    updatedAt: string;
  }>;
}

// Current affiliate query
export const CURRENT_AFFILIATE_QUERY = gql`
  query CurrentAffiliate {
    myAffiliate {
      id
      userId
      referralCode
      status
      commissionAmount
      totalEarnings
      totalConversions
      pendingPayout
      createdAt
    }
  }
`;

export const AFFILIATE_STATS_QUERY = CURRENT_AFFILIATE_QUERY;

export interface CurrentAffiliateQueryResponse {
  myAffiliate: {
    id: string;
    userId: string;
    referralCode: string;
    status: string;
    commissionAmount: number;
    totalEarnings: number;
    totalConversions: number;
    pendingPayout: number;
    createdAt: string;
  };
}

// Affiliate performance query
export const AFFILIATE_PERFORMANCE = gql`
  query AffiliatePerformance($affiliateId: ID!) {
    affiliatePerformance(affiliateId: $affiliateId) {
      totalEarnings
      totalConversions
      pendingPayout
      paidOut
    }
  }
`;

export interface AffiliatePerformanceQueryVariables {
  affiliateId: string;
  startDate?: string;
  endDate?: string;
}

export interface AffiliatePerformanceQueryResponse {
  affiliatePerformance: {
    totalEarnings: number;
    totalConversions: number;
    pendingPayout: number;
    paidOut: number;
  };
}

// Affiliate conversions query
export const AFFILIATE_CONVERSIONS_QUERY = gql`
  query AffiliateConversions($affiliateId: ID, $status: ConversionStatus, $limit: Int, $offset: Int) {
    conversions(affiliateId: $affiliateId, status: $status, limit: $limit, offset: $offset) {
      id
      affiliateId
      referralCode
      artistId
      artist {
        id
        email
        firstName
        lastName
      }
      commissionAmount
      status
      approvedAt
      paidAt
      rejectedAt
      rejectionReason
      createdAt
      updatedAt
    }
  }
`;

export const AFFILIATE_CONVERSIONS = AFFILIATE_CONVERSIONS_QUERY;

export interface AffiliateConversionsQueryVariables {
  affiliateId?: string;
  status?: 'pending' | 'approved' | 'paid' | 'rejected';
  limit?: number;
  offset?: number;
}

export interface AffiliateConversionsQueryResponse {
  conversions: Array<{
    id: string;
    affiliateId: string;
    referralCode: string;
    artistId: string;
    artist: {
      id: string;
      email: string;
      firstName?: string;
      lastName?: string;
    };
    commissionAmount: number;
    status: string;
    approvedAt?: string;
    paidAt?: string;
    rejectedAt?: string;
    rejectionReason?: string;
    createdAt: string;
    updatedAt: string;
  }>;
}

// Single affiliate query
export const AFFILIATE_QUERY = gql`
  query Affiliate($id: ID!) {
    affiliate(id: $id) {
      id
      userId
      referralCode
      status
      commissionAmount
      totalEarnings
      totalConversions
      pendingPayout
      paidOut
      createdAt
      approvedAt
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

export interface AffiliateQueryVariables {
  id: string;
}

export interface AffiliateQueryResponse {
  affiliate: {
    id: string;
    userId: string;
    referralCode: string;
    status: string;
    commissionAmount: number;
    totalEarnings: number;
    totalConversions: number;
    pendingPayout: number;
    paidOut: number;
    createdAt: string;
    approvedAt?: string;
    user: {
      firstName: string;
      lastName: string;
      email: string;
    };
  };
}

// Affiliate by code query
export const AFFILIATE_BY_CODE_QUERY = gql`
  query AffiliateByCode($code: String!) {
    affiliateByCode(code: $code) {
      id
      userId
      referralCode
      status
      commissionAmount
      totalEarnings
      totalConversions
      createdAt
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

export interface AffiliateByCodeQueryVariables {
  code: string;
}

export interface AffiliateByCodeQueryResponse {
  affiliateByCode: {
    id: string;
    userId: string;
    referralCode: string;
    status: string;
    commissionAmount: number;
    totalEarnings: number;
    totalConversions: number;
    createdAt: string;
    user: {
      firstName: string;
      lastName: string;
      email: string;
    };
  };
}
